import { Injectable, inject } from '@angular/core';

import { Rest, RestService } from '@abp/ng.core';
import { Observable } from 'rxjs';

import {
  SammApplication,
 SammInstanceTypeDetailsDto,
 SammInstanceTypeDto, SammInstanceTypeReferenceDto, SammSolutionRole
} from '../models/';

@Injectable({
  providedIn: 'root'
})
export class SammApplicationService {
  private rest = inject(RestService);

  private apiUrl = `/api/Samm/samm-lookup`;

  /**
   *
   * @param params
   * @returns
   */
  public getSammApplications(includeAllOption?: boolean): Observable<SammApplication[]> {
    const request: Rest.Request<null> = {
      method: 'GET',
      url: `${this.apiUrl}/samm-applications`,
      params: { includeAllOption }
    };

    return this.rest.request<null, SammApplication[]>(request);
  }

  public getServerTime(): Observable<string> {
    const request: Rest.Request<null> = {
      method: 'GET',
      url: `${this.apiUrl}/server-time`
    };

    return this.rest.request<null, string>(request);
  }

  public getSammSolutionRoles$(includeAllOption?: boolean): Observable<SammSolutionRole[]> {
    const request: Rest.Request<null> = {
      method: 'GET',
      url: `${this.apiUrl}/samm-solution-roles`,
      params: { includeAllOption }
    };

    return this.rest.request<null, SammSolutionRole[]>(request);
  }

  public getSammInstanceTypeReferences$(instanceTypeId: number, includeDefaultOption: boolean = false) {
    const request: Rest.Request<null> = {
      method: 'GET',
      url: `${this.apiUrl}/samm-instance-type-references/${instanceTypeId}`,
      params: { instanceTypeId, includeDefaultOption }
    };

    return this.rest.request<null, SammInstanceTypeReferenceDto[]>(request, { skipHandleError: true });
  }

  public getSammInstanceTypes$(): Observable<SammInstanceTypeDto[]> {
    const request: Rest.Request<null> = {
      method: 'GET',
      url: `${this.apiUrl}/samm-instance-types`
    };

    return this.rest.request<null, SammInstanceTypeDto[]>(request);
  }

  public getSammInstanceTypeDetails$(instanceTypeId: number, includeReferences: boolean = false): Observable<SammInstanceTypeDetailsDto> {
    const request: Rest.Request<null> = {
      method: 'GET',
      url: `${this.apiUrl}/samm-instance-type/${instanceTypeId}`,
      params: { instanceTypeId, includeReferences }
    };

    return this.rest.request<null, SammInstanceTypeDetailsDto>(request);
  }
}
